import React, { memo } from 'react'
import { Keyboard } from 'react-native'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigation } from '@react-navigation/native'
import Haptic from '@utils/haptic'
import { calendarDateSelector } from '@src/selectors/app'
import { allEventsCalendarDateSelector } from '@src/screens/Events/models/allEvents.selectors'
import { insightsCalendarSelector } from '@src/screens/Insights/models/insights.selectors'
import { mealsCalendarSelector } from '@src/selectors/meals'
import { planCalendarDateSelector } from '@src/screens/Plan/models/plan.selectors'
import { DateSelector } from './DateSelector'
import { DateSelectorMode, DateSelectorType } from './types'

interface DateSelectorControllerProps {
  type?: DateSelectorType
  allowRangeSelection?: boolean
  dateSelectorMode?: DateSelectorMode
  allowFutureDates?: boolean
  hideCalendarIcon?: boolean
  forceLandscapeOrientation?: boolean
}

const typeToSelector = {
  app: calendarDateSelector,
  allEvents: allEventsCalendarDateSelector,
  insights: insightsCalendarSelector,
  meals: mealsCalendarSelector,
  plan: planCalendarDateSelector,
}

export const DateSelectorController = memo(
  ({
    type = 'app',
    allowRangeSelection = true,
    dateSelectorMode = DateSelectorMode.DAY,
    allowFutureDates = true,
    hideCalendarIcon = false,
    forceLandscapeOrientation,
  }: DateSelectorControllerProps) => {
    const dispatch = useDispatch()
    const navigation = useNavigation()

    const selector = typeToSelector[type]
    const { startDate, endDate } = useSelector(selector)

    const onDateChange = (startDate: string, endDate: string) => {
      Haptic.heavyTap()

      dispatch({
        type: `${type}/changeDateRange`,
        payload: { startDate, endDate },
      })
    }

    const onDatePickerPress = () => {
      if (forceLandscapeOrientation || type === 'plan') {
        return
      }
      Haptic.heavyTap()
      Keyboard.dismiss()

      navigation.navigate('ChangeDateRange', { type, allowRangeSelection })
    }

    return (
      <DateSelector
        startDate={startDate}
        endDate={endDate}
        dateSelectorMode={dateSelectorMode}
        allowFutureDates={allowFutureDates}
        hideCalendarIcon={hideCalendarIcon}
        onDatePickerPress={onDatePickerPress}
        onDateChange={onDateChange}
      />
    )
  },
)
